class ComponentIngredientToggle extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();

    this.index = 0;
    this.visible = false;
    this.held = false;
    this.stopped = false;
    this.timer = null;

    this.interval = (parseFloat(this.dataset.interval) || 1.2) * 1000;
    this.reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    this.addDirectEvent("pointerenter", this, () => this.hold(true));
    this.addDirectEvent("pointerleave", this, () => this.hold(false));
    this.addDirectEvent("focusin", this, () => this.hold(true));
    this.addDirectEvent("focusout", this, () => this.hold(false));

    this.intersectionObserver((entry) => {
      this.visible = entry.isIntersecting;
      this.schedule();
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    clearTimeout(this.timer);
  }

  select({ index }) {
    this.stopped = true;

    this.show(index);
  }

  show(index) {
    const { tab, art, panel } = this.elements;

    this.index = (index + tab.length) % tab.length;

    tab.forEach((element, position) => {
      element.classList.toggle("state--active", position === this.index);
      element.setAttribute("aria-selected", position === this.index);
    });

    art.forEach((element, position) => {
      element.classList.toggle("state--active", position === this.index);
    });

    panel.forEach((element, position) => {
      element.classList.toggle("state--active", position === this.index);
      element.setAttribute("aria-hidden", position !== this.index);
    });

    this.schedule();
  }

  schedule() {
    clearTimeout(this.timer);

    if (this.reduced || this.stopped || this.held || !this.visible) {
      return;
    }

    this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
  }

  hold(held) {
    this.held = held;

    this.schedule();
  }
}

customElements.define("component-ingredient-toggle", ComponentIngredientToggle);
